var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c(
        "app-section",
        [_c("app-title", [_vm._v(_vm._s(_vm.$ct("title")))])],
        1
      ),
      !_vm.finished
        ? [
            _c(
              "app-section",
              [
                _c("w-input", {
                  attrs: {
                    label: _vm.$ct("label"),
                    password: "",
                    fancy: "",
                    required: "",
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
                _c("w-input", {
                  staticClass: "mt",
                  attrs: {
                    label: _vm.$ct("label-repeat"),
                    password: "",
                    fancy: "",
                    required: "",
                    validators: [_vm.isSameValidator],
                  },
                  model: {
                    value: _vm.repeatPassword,
                    callback: function ($$v) {
                      _vm.repeatPassword = $$v
                    },
                    expression: "repeatPassword",
                  },
                }),
              ],
              1
            ),
            _c(
              "app-section",
              [
                _c(
                  "app-button",
                  {
                    attrs: { disabled: _vm.buttonDisabled },
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("action")) + " ")]
                ),
                _c(
                  "app-text",
                  { staticClass: "mt" },
                  [
                    _c("w-link", { attrs: { to: "/" } }, [
                      _vm._v(" " + _vm._s(_vm.$ct("back")) + " "),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _c(
            "app-section",
            [
              _c(
                "app-text",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("completed")) + " "),
                  _c("w-link", { attrs: { to: "/" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("back")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }